<template>
  <el-dialog :title="$t('res.site.selectSiteInfo')"
             :show-close="false"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             append-to-body
             width="90%">
    <div style="margin-top: 5px;">
      <el-row :gutter="10">
        <el-col :span="18">
          <el-card class="box-card">
            <el-form :label-position="labelPosition"
                     :label-width="queryLabelWidth"
                     :model="dataForm"
                     ref="dataForm"
                     @keyup.enter.native="querySiteInfo()"
                     @submit.native.prevent>
              <el-row :gutter="0">
                <!--场地名称-->
                <el-col :span="6">
                  <el-form-item :label="$t('res.site.name')"
                                style="width: 98%!important;">
                    <el-input v-model.trim="dataForm.siteCnName"
                              :placeholder="$t('res.site.name')"
                              clearable></el-input>
                  </el-form-item>
                </el-col>
                <!--场地编码-->
                <el-col :span="6">
                  <el-form-item :label="$t('res.site.code')"
                                style="width: 98%!important;">
                    <el-input v-model.trim="dataForm.siteNo"
                              :placeholder="$t('res.site.code')"
                              clearable></el-input>
                  </el-form-item>
                </el-col>
                <!--场地分类-->
                <el-col :span="6">
                  <el-form-item :label="$t('res.site.classification')"
                                style="width: 98%!important;">
                    <class-tree ref="classRef"
                                v-model="dataForm.siteClassList"
                                v-on:getSelectList="getSelectList"
                                v-bind:defaultProps="defaultProps"
                                v-bind:url="queryTreeUrl"
                                v-bind:isSelect=false
                                v-bind:status="'siteClassStatus'"></class-tree>
                  </el-form-item>
                </el-col>
                <el-col :span="3"
                        class="query-button">
                  <el-form-item>
                    <el-button style="margin-bottom: 7px"
                               type="primary"
                               @click="querySiteInfo()">{{ $t('query') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--活动状态-->
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('res.site.status')"
                                style="width: 98%!important;">
                    <el-select multiple
                               collapse-tags
                               v-model="dataForm.statusList"
                               :placeholder="$t('res.site.status')"
                               clearable>
                      <el-option v-for="(item,index) in statusArr"
                                 :key="index"
                                 :label="item.name"
                                 :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--所在城市-->
                <el-col :span="6"
                        class="padt7">
                  <el-form-item :label="$t('res.site.city')"
                                style="width: 98%!important;">
                    <address-select :level="2"
                                v-model="dataForm.regionIds"
                                :placeholder="$t('organization.cityIds')">
                    </address-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                  </el-form-item>
                </el-col>
                <el-col :span="3"
                        class="query-button">
                  <el-form-item>
                    <el-button class="el-back"
                               type="info"
                               @click="resetQueryData()">{{ $t('reset') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="dataBox"
                 id="gridBox">
              <el-table :data="dataList"
                        border
                        class="jySelectionAll"
                        :header-cell-style="{background: '#f1f1f1'}"
                        v-loading="dataListLoading"
                        ref="siteInfoTableRef"
                        @select-all="selectAll"
                        @select="selectRedio"
                        style="width: 100%;">
                <el-table-column type="selection"
                                 header-align="center"
                                 align="center"
                                 width="50">
                </el-table-column>
                <!-- 序号 -->
                <el-table-column type="index"
                                 header-align="center"
                                 align="center"
                                 :index="indexCreate"
                                 prop="xh"
                                 width="50"
                                 :label="$t('res.cri.serialNo')">
                </el-table-column>
                <!-- 场地编号 -->
                <el-table-column prop="siteNo"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.code')">
                </el-table-column>
                <!-- 场地名称 -->
                <el-table-column prop="siteCnName"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.name')">
                </el-table-column>
                <!-- 场地简称 -->
                <el-table-column prop="siteAbbr"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.shortName')">
                </el-table-column>
                <!--所属分类-->
                <el-table-column prop="siteType"
                                 :formatter="siteTypeFormatter"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.type')">
                </el-table-column>
                <!--所属公司-->
                <el-table-column prop="companyCnName"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.company')">
                </el-table-column>
                <!--所在城市-->
                <el-table-column prop="cityName"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.city')">
                </el-table-column>
                <!--场地分类-->
                <el-table-column prop="siteClassCnName"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.classification')">
                </el-table-column>
                <!--场地状态-->
                <el-table-column :formatter="statusFormatter"
                                 prop="status"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.site.status')">
                </el-table-column>
              </el-table>
              <el-pagination @size-change="pageSizeChangeHandle"
                             @current-change="pageCurrentChangeHandle"
                             :current-page="page"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="limit"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="total">
              </el-pagination>
              <br>
            </div>
          </el-card>
        </el-col>

        <!--已选场地-->
        <el-col :span="6">
          <el-card>
            <div>
              <el-form :model="dataForms"
                       ref="dataForms">
                <div class="location-layout">
                  <span class="dataBox">{{$t('res.site.selected')}}</span>
                  <el-row :gutter="10">
                    <el-col v-for="tag in vehicleData"
                            :key="tag.siteCnName">
                      <el-tag show-overflow-tooltip
                              style="margin-bottom: 10px;width: 250px"
                              :key="tag.siteCnName"
                              @close="handleClose(tag)"
                              closable>
                        <div style="width:90%;float:left;overflow-x:hidden; overflow-y:hidden; word-break:keep-all; white-space:nowrap;">{{tag.siteCnName}}</div>
                      </el-tag>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </el-card>
          <div style="text-align:right;">
            <el-button size="mini"
                       type="primary"
                       @click="closeSuboSiteDlg">取 消</el-button>
            <el-button size="mini"
                       type="primary"
                       @click="bringBack">确 定</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
import AddressSelect from '@/components/address-select'
import ClassTree from '@/components/rm/class-tree/index'
import RegionTree from '@/components/region-tree/index'
import Vue from 'vue'
export default {
  name: 'subordinate-site',
  props: {
    dialogVisible: Boolean,
    // true:单选；false：多选
    isSingleElection: {
      type: Boolean,
      default: false
    },
    selectTable: {
      type: Array,
      required: false
    }
  },
  components: {
    AddressSelect,
    'class-tree': ClassTree,
    'region-tree': RegionTree
  },
  data () {
    return {
      list: [],
      mixinViewModuleOptions: {
        getDataListURL: '/rm/siteinfo/list',
        getDataListIsPage: true
      },
      dataListLoading: false,
      vehicleData: [],
      dataForm: {
        siteCnName: '',
        siteNo: '',
        regionIds: [],
        siteClassList: [],
        statusList: []
      },
      dataForms: {
        priority: ''
      },
      dataList: [],
      // 编辑面板标签对齐方式
      labelPosition: 'left',
      // 查询面板标签宽度
      queryLabelWidth: '70px',
      page: 1, // 当前页码
      limit: 10, // 每页数
      total: 0, // 总条数deleteURL
      defaultProps: {
        children: 'children',
        label: 'siteClassCnName'
      },
      queryTreeUrl: '/rm/siteclass/list',
      // 城市分类
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      queryCityTreeUrl: '/learning/otherinfo/list',
      // 状态
      statusArr: this.enums['status']
    }
  },
  activated () {
    // this.$nextTick(() => {

    //   if (this.$refs['dataForm']) {
    //     this.$refs['dataForm'].resetFields()
    //   }
    //   if (this.$route.query.siteId !== undefined) {
    //     this.dataForm.userTrainingId = this.$route.query.siteId
    //     this.getDataList()
    //   }
    // })
  },
  methods: {
    // 获取信息
    initSuborSite () {
      this.page = 1
      // 将已选场地清空
      this.vehicleData = []
      if (this.selectTable && this.selectTable.length > 0) {
        this.vehicleData = this.selectTable
      }
      this.dataForm = {}
      this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      this.$refs.classRef && this.$refs.classRef.resetChecked()
      this.$refs.regionTree && this.$refs.regionTree.resetChecked()
      this.getDataList()
    },
    // 获取数据列表
    getDataList () {
      console.info(this.dataForm)
      this.dataForm.cityClassList = this.dataForm.regionIds
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        console.warn(data.result)
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
        // 延迟加载
        this.$nextTick(() => {
          this.querSelect()
        })
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    selectAll (selection) {
      let _this = this
      if (selection) {
        let courseDataB = []
        courseDataB = _this.vehicleData
        if (selection.length > 0) {
          for (var i = 0; i < selection.length; i++) {
            let hasFlg = false
            if (courseDataB.length > 0) {
              for (var l = 0; l < courseDataB.length; l++) {
                if (courseDataB[l].siteNo === selection[i].siteNo) {
                  hasFlg = true
                }
              }
            }
            if (!hasFlg) {
              _this.vehicleData.push(selection[i])
            }
          }
        } else {
          _this.vehicleData = []
          if (courseDataB.length > 0) {
            courseDataB.forEach(item => {
              let index = _this.dataList.findIndex(it => it.siteNo === item.siteNo)
              if (index === -1) {
                _this.vehicleData.push(item)
              }
            })
          }
        }
      }
    },
    selectRedio: function selectRedio (selection, row) {
      let result = []
      for (let a = 0; a < selection.length; a++) {
        if (row.siteNo === selection[a].siteNo) {
          result.push(row)
          break
        }
      }
      if (result.length > 0) {
        if (this.isSingleElection && this.vehicleData.length === 1) {
          this.$refs.siteInfoTableRef.clearSelection()// 清空
          this.vehicleData = []
          this.vehicleData.push(row)
          this.$refs.siteInfoTableRef.toggleRowSelection(row)// 选择当前行
        } else {
          if (row) {
            if (this.vehicleData) {
              for (var i = 0; i < this.vehicleData.length; i++) {
                if (String(this.vehicleData[i].siteNo) === String(row.siteNo)) {
                  this.$message.warning(this.$t('res.site.ondb'))
                  return false
                }
              }
            }
            this.vehicleData.push(row)
          }
        }
      } else {
        if (this.isSingleElection && this.vehicleData.length === 1) {
          this.$refs.siteInfoTableRef.clearSelection()// 清空
          this.vehicleData = []
        } else {
          for (let b = 0; b < this.vehicleData.length; b++) {
            if (row.siteNo === this.vehicleData[b].siteNo) {
              this.vehicleData.splice(b, 1)
              break
            }
          }
        }
      }
    },
    backPage () {
      this.$router.go(-1)
    },
    resetQueryData () {
      this.initSuborSite()
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.getDataList()
    },
    // 关闭dialog
    closeSuboSiteDlg () {
      this.$emit('closeSuboSiteDlg')
    },
    // 带回主页面
    bringBack () {
      let currSelection = []
      if(!this.vehicleData || this.vehicleData.length <= 0){
        currSelection = []
      }else{
        currSelection = this.vehicleData
      }



      this.$emit('bringBack', currSelection)
      this.vehicleData = []
    },
    getSelectList (args) {
      let siteClass = []
      args.forEach(function (item) {
        siteClass.push(item.id)
      })
      this.dataForm.siteClassList = siteClass
    },
    getcitySelectList (args) {
      let cityClass = []
      args.forEach(function (item) {
        cityClass.push(item.regionId)
      })
      this.dataForm.cityClassList = cityClass
    },
    // 所属分类的转换
    siteTypeFormatter (row) {
      return Vue.filter('coverEnum')(row.siteType, 'orgType')
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 生成网格的序号
    indexCreate (index) {
      return (this.page - 1) * this.limit + (index + 1)
    },
    // 查询按钮
    querySiteInfo () {
      this.page = 1
      this.getDataList()
    },
    // 打开页面时，回填勾选
    querSelect () {
      if (this.vehicleData && this.vehicleData.length > 0) {
        var map = new Map()
        this.vehicleData.forEach(function (item, index) {
          map.set(item.id, item)
        })
        let _this = this
        _this.dataList.forEach(function (dataitem, dataindex) {
          if (map.has(dataitem.id)) {
            _this.$refs.siteInfoTableRef.toggleRowSelection(dataitem)
          }
        })
      }
    },
    // 删除已选场地
    handleClose (data) {
      for (let a = 0; a < this.dataList.length; a++) {
        if (data.id === this.dataList[a].id) {
          this.$refs.siteInfoTableRef.toggleRowSelection(this.dataList[a], false)// 选择当前行
          break
        }
      }

      this.vehicleData.splice(this.vehicleData.indexOf(data), 1)
    },
    // 双击选择车辆数据
    // onDbVehicle (val) {
    //   if (val) {
    //     if (this.vehicleData) {
    //       for (var i = 0; i < this.vehicleData.length; i++) {
    //         if (String(this.vehicleData[i].siteNo) === String(val.siteNo)) {
    //           this.$message.warning(this.$t('res.site.ondb'))
    //           return false
    //         }
    //       }
    //     }
    //     this.vehicleData.push(val)
    //     val.siteCnName = val.siteCnName
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
/* 隐藏网格的全选按钮 */

#gridBox .el-table th {
  background: #ebecf0 !important;
  border-right: 1px #dcdee3 solid;
}
  .el-row {
    margin-bottom: 0 !important;
  }
</style>
